import { withFormValidation } from '@updater/ui-form-element';
import { applyAsAttributes, withHTMLComponent } from '@updater/ui-custom-element';

var styles = ":host {\n  display: block;\n}\n\n#input {\n  position: absolute;\n  opacity: 0;\n  margin: 0;\n  width: 1.25em;\n  height: 1.25em;\n}\n";

var styles$1 = ":host {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  border-color: #efefef;\n  height: 100%;\n}\n\n#input {\n  position: absolute;\n  opacity: 0;\n  margin: 0;\n  width: 1.25em;\n  height: 1.25em;\n}\n\n#radio {\n  flex: 0 0 auto;\n  align-self: flex-start;\n  display: flex;\n  box-sizing: border-box;\n  justify-content: center;\n  align-items: center;\n  width: 1.25em;\n  height: 1.25em;\n  background: white;\n  border: 0.0625em solid #efefef;\n  border-radius: 50%;\n  margin-right: 0.625em;\n}\n\n#label {\n  font-weight: 300;\n  user-select: none;\n}\n\n#helper {\n  font-size: 0.75em;\n  font-weight: 300;\n  font-style: italic;\n  line-height: 1.5;\n}\n\n#helper:empty {\n  display: none;\n}\n\n#fill {\n  opacity: 0;\n  width: 0.75em;\n  height: 0.75em;\n  background: #2b7499;\n  border-radius: 50%;\n  transition: opacity 0.2s;\n}\n\n:host([aria-checked='true']) #fill {\n  opacity: 1;\n}\n\n:host(:not([disabled]):active) #radio {\n  background: #f3fcff;\n}\n\n:host(:not([disabled]):hover) #radio {\n  border-color: #aac7d6;\n}\n\n:host(:not([disabled]):focus) #radio,\n:host(:not([disabled])[aria-checked='true']) #radio {\n  border-color: #2b7499;\n}\n\n:host(:not([disabled]).upd-invalid.upd-validated) {\n  color: #f84e57;\n}\n\n:host(:not([disabled]).upd-invalid.upd-validated) #radio {\n  border-color: #f84e57;\n}\n\n:host(:not([disabled]).upd-invalid.upd-validated) #fill {\n  background: #f84e57;\n}\n\n:host(:not([disabled]).upd-invalid.upd-validated:hover),\n:host(:not([disabled]).upd-invalid.upd-validated:focus) {\n  color: #ab232c;\n}\n\n:host(:not([disabled]).upd-invalid.upd-validated:hover) #radio,\n:host(:not([disabled]).upd-invalid.upd-validated:focus) #radio {\n  border-color: #ab232c;\n}\n\n:host(:not([disabled]).upd-invalid.upd-validated:focus) #fill {\n  background: #ab232c;\n}\n\n:host(:not([disabled]).upd-invalid.upd-validated:active) #radio {\n  background: #fde2e4;\n}\n\n:host([disabled]) {\n  color: #efefef;\n}\n\n:host([disabled]) #fill {\n  background: #efefef;\n}\n\n:host(:focus) {\n  outline: none;\n}\n";

var html$1 = "<div id=\"radio\">\n  <div id=\"fill\"></div>\n</div>\n<div>\n  <label id=\"label\">\n    <slot name=\"label\"></slot>\n  </label>\n  <div id=\"helper\">\n    <slot name=\"helper\"></slot>\n  </div>\n</div>\n";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var SPACE_KEY = 32;
var OBSERVED_ATTRS$1 = ['disabled', 'helper', 'label', 'value'];

var RadioOption = function (_withHTMLComponent) {
  inherits(RadioOption, _withHTMLComponent);

  function RadioOption() {
    classCallCheck(this, RadioOption);

    var _this = possibleConstructorReturn(this, (RadioOption.__proto__ || Object.getPrototypeOf(RadioOption)).call(this));

    _this._handleClick = function (event) {
      if (_this.disabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    _this._handleSlotClick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (_this.disabled) {
        return;
      }
      // reroute slot-click through shadow-dom
      // so target is upd-radio-option
      _this.dispatchEvent(new Event('click', {
        bubbles: true,
        composed: true
      }));
    };

    _this._handleKeyPress = function (event) {
      // Don’t handle modifier shortcuts typically used by assistive technology.
      if (event.altKey || _this.disabled) {
        return;
      }

      if (event.keyCode === SPACE_KEY) {
        // Prevent scrolling on space key press
        event.preventDefault();

        if (event.type === 'keyup') {
          _this.dispatchEvent(new Event('click', {
            bubbles: true,
            composed: true
          }));
        }
      }
    };

    _this._label = _this.shadowRoot.querySelector('#label');
    _this._labelSlot = _this.shadowRoot.querySelector('slot[name="label"]');
    _this._helper = _this.shadowRoot.querySelector('#helper');
    _this._helperSlot = _this.shadowRoot.querySelector('slot[name="helper"]');
    return _this;
  }

  createClass(RadioOption, [{
    key: 'connected',
    value: function connected() {
      var _this2 = this;

      this.role = this.role || 'radio';

      this.addEventListener('click', this._handleClick);
      this.addEventListener('keyup', this._handleKeyPress);
      this.addEventListener('keydown', this._handleKeyPress);
      this._labelSlot.addEventListener('slotchange', function () {
        if (_this2._labelSlot.assignedNodes()) {
          [].concat(toConsumableArray(_this2._labelSlot.assignedNodes())).forEach(function (el) {
            el.addEventListener('click', _this2._handleSlotClick);
          });

          _this2.ariaLabel = _this2._labelSlot.assignedNodes().map(function (n) {
            return n.textContent;
          }).join();
        }
      });
      this._helperSlot.addEventListener('slotchange', function () {
        if (_this2._helperSlot.assignedNodes()) {
          [].concat(toConsumableArray(_this2._helperSlot.assignedNodes())).forEach(function (el) {
            el.addEventListener('click', _this2._handleSlotClick);
          });
        }
      });

      // In polyfilled browsers, `radio-option`s are added to the DOM before the
      // `radio-group` parent. Wait to ensure the parent is present before adding
      // the listener. TODO: Remove, if and when we can drop the polyfill
      Promise.resolve().then(function () {
        _this2.dispatchEvent(new CustomEvent('updradiooptionconnected', {
          bubbles: true,
          composed: true
        }));
      });
    }
  }, {
    key: 'disconnected',
    value: function disconnected() {
      var _this3 = this;

      this.dispatchEvent(new CustomEvent('updradiooptiondisconnected', {
        bubbles: true,
        composed: true
      }));

      this.removeEventListener('click', this._handleClick);
      this.removeEventListener('keyup', this._handleKeyPress);
      this.removeEventListener('keydown', this._handleKeyPress);
      if (this._labelSlot.assignedNodes()) {
        [].concat(toConsumableArray(this._labelSlot.assignedNodes())).forEach(function (el) {
          el.removeEventListener('click', _this3._handleSlotClick);
        });
      }
      if (this._helperSlot.assignedNodes()) {
        [].concat(toConsumableArray(this._helperSlot.assignedNodes())).forEach(function (el) {
          el.removeEventListener('click', _this3._handleSlotClick);
        });
      }
    }
  }, {
    key: 'updated',
    value: function updated(_ref) {
      var disabled = _ref.disabled,
          helper = _ref.helper,
          label = _ref.label;

      this._handleDisabled(disabled);
      if (helper) {
        // only set textContent if helper is supplied as an attribute
        // thereby preserving the slot in html if helper is html and not string
        this._helper.textContent = helper;
      }
      if (label) {
        this._label.textContent = label;
        this.ariaLabel = label;
      }
    }
  }, {
    key: '_handleDisabled',
    value: function _handleDisabled(isDisabled) {
      this.ariaDisabled = isDisabled.toString();
      this.tabIndex = isDisabled ? null : -1;
      this.blur();
    }
  }, {
    key: 'checked',
    get: function get$$1() {
      return this.ariaChecked === 'true';
    }
  }]);
  return RadioOption;
}(withHTMLComponent(styles$1, html$1)());

RadioOption.observedAttributes = OBSERVED_ATTRS$1;
RadioOption.reflectedAttributes = OBSERVED_ATTRS$1.concat(['aria-checked', 'aria-disabled', 'aria-label', 'role', 'tabindex']);
RadioOption.attributeTypes = {
  disabled: 'boolean'
};


window.customElements.define('upd-radio-option', RadioOption);

// https://stackoverflow.com/questions/5899783/detect-safari-using-jquery
var parseSafariVersion = function parseSafariVersion(userAgent) {
  return (userAgent.match(/^(?:(?!chrome|android).)*Version\/([\d.]+).*safari/i) || [])[1] || null;
};

var applySafariReflowFix = function applySafariReflowFix(element) {
  if (parseInt(parseSafariVersion(navigator.userAgent), 10) < 11) {
    // Safari 10 and below fails to update styles in response to classes being added/removed.
    // https://stackoverflow.com/questions/3485365/how-can-i-force-webkit-to-redraw-repaint-to-propagate-style-changes
    var previousDisplay = element.style.display;
    element.style.display = 'none';
    element.offsetHeight;
    element.style.display = previousDisplay;
  }
};

var KEYS = {
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  UP: 38
};

var OBSERVED_ATTRS = ['disabled', 'required', 'name', 'value'];

var html = '\n  <input type="radio" id="input" tabindex="-1" />\n  <slot></slot>\n';

var RadioGroup = function (_withFormValidation) {
  inherits(RadioGroup, _withFormValidation);

  function RadioGroup() {
    classCallCheck(this, RadioGroup);

    var _this = possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this));

    _this._state = {
      options: [],
      validated: false
    };

    _this._handleClick = function (_ref) {
      var _ref$target = _ref.target,
          localName = _ref$target.localName,
          value = _ref$target.value;

      if (localName === 'upd-radio-option') {
        _this._commitValue(value);
      }
    };

    _this._handleConnectedOption = function (event) {
      event.stopPropagation();
      _this.mergeState({ options: [].concat(toConsumableArray(_this._state.options), [event.target]) });
    };

    _this._handleDisconnectedOption = function (event) {
      event.stopPropagation();
      _this.mergeState({
        options: _this._state.options.filter(function (option) {
          return option !== event.target;
        })
      });
    };

    _this._handleKeydown = function (event) {
      switch (event.keyCode) {
        case KEYS.LEFT:
        case KEYS.UP:
          event.preventDefault();
          _this._shiftFocus(-1);
          break;
        case KEYS.RIGHT:
        case KEYS.DOWN:
          event.preventDefault();
          _this._shiftFocus(1);
          break;
      }
    };

    _this._handleValidation = function (event) {
      // Since we can't use host-context (it's in the spec, but only Chrome has
      // implemented) for children we walk each child node and apply
      // upd-validated and upd-invalid classes when appropriate.
      composedTreeWalk(_this.shadowRoot, function (node) {
        node.classList.add('upd-validated');
        !_this.validity.valid ? node.classList.add('upd-invalid') : node.classList.remove('upd-invalid');
      });
    };

    _this._input = _this.shadowRoot.querySelector('#input');
    return _this;
  }

  createClass(RadioGroup, [{
    key: 'connected',
    value: function connected() {
      this.role = this.role || 'radiogroup';

      this.addEventListener('click', this._handleClick);
      this.addEventListener('keydown', this._handleKeydown);
      this.addEventListener('updradiooptionconnected', this._handleConnectedOption);
      this.addEventListener('updradiooptiondisconnected', this._handleDisconnectedOption);
      this.addEventListener('updvalidation', this._handleValidation);
    }
  }, {
    key: 'disconnected',
    value: function disconnected() {
      this.removeEventListener('click', this._handleClick);
      this.removeEventListener('keydown', this._handleKeydown);
      this.removeEventListener('updradiooptionconnected', this._handleConnectedOption);
      this.removeEventListener('updradiooptiondisconnected', this._handleDisconnectedOption);
      this.removeEventListener('updvalidation', this._handleValidation);
    }
  }, {
    key: 'updated',
    value: function updated(_ref2, _ref3) {
      var options = _ref2._state.options,
          value = _ref2.value,
          name = _ref2.name,
          disabled = _ref2.disabled,
          required = _ref2.required;
      var oldValue = _ref3.value;

      this.ariaDisabled = disabled.toString();

      applyAsAttributes(this._input, {
        checked: value,
        disabled: disabled,
        name: name,
        required: required
      });

      options.forEach(function (option) {
        var isSelected = option.value === value;
        option.ariaChecked = isSelected.toString();
        option.tabIndex = isSelected ? 0 : -1;
        option.disabled = option.disabled || disabled;
      });

      if (!value) {
        (options[0] || {}).tabIndex = 0;
      }

      if (value !== oldValue) {
        this.checkValidity();
      }

      applySafariReflowFix(this);
    }
  }, {
    key: '_commitValue',
    value: function _commitValue(value) {
      if (this.value !== value) {
        this.value = value;

        // Only dispatch `change` if `value` was changed through user interaction.
        this.dispatchEvent(new CustomEvent('change', {
          bubbles: true,
          composed: true,
          detail: value
        }));
      }
    }
  }, {
    key: '_shiftFocus',
    value: function _shiftFocus(direction) {
      var options = this._state.options.filter(function (opt) {
        return !opt.disabled;
      });
      var index = options.findIndex(function (option) {
        return option.tabIndex === 0;
      });
      var length = options.length;

      var focusOption = options[(index + length + direction) % length];

      this._commitValue(focusOption.value);
      focusOption && focusOption.focus();
    }
  }]);
  return RadioGroup;
}(withFormValidation(withHTMLComponent(styles, html)()));

RadioGroup.observedAttributes = OBSERVED_ATTRS;
RadioGroup.reflectedAttributes = OBSERVED_ATTRS.concat(['aria-checked', 'aria-disabled', 'checked', 'role']);
RadioGroup.attributeTypes = {
  disabled: 'boolean',
  checked: 'boolean',
  required: 'boolean'
};


window.customElements.define('upd-radio-group', RadioGroup);

// TODO: Consolidate these utilities into a package
//
// Recursively walk the composed tree from node.
// Taken and slightly modified from
// https://github.com/WICG/inert/blob/master/src/inert.js#L607
function composedTreeWalk(node, callback) {
  if (node.nodeType === Node.ELEMENT_NODE) {
    if (callback) {
      callback(node);
    }

    // Descend into node:
    // If it has a ShadowRoot, ignore all child elements - these will be picked
    // up by the <slot> or <shadow> elements. Descend straight into the
    // ShadowRoot.
    var shadowRoot = node.shadowRoot;
    if (shadowRoot) {
      composedTreeWalk(shadowRoot, callback);
      return;
    }

    // If it is a <slot> element, descend into assigned nodes - these
    // are elements from outside the shadow root which are rendered inside the
    // shadow DOM.
    if (node.localName === 'slot') {
      var distributedNodes = node.assignedNodes ? node.assignedNodes({ flatten: true }) : [];
      distributedNodes.forEach(function (distributedNode) {
        composedTreeWalk(distributedNode, callback);
      });
      return;
    }
  }

  // If it is neither the parent of a ShadowRoot, a <slot> element, nor a <shadow> element recurse normally.
  var child = node.firstChild;
  while (child != null) {
    composedTreeWalk(child, callback);
    child = child.nextSibling;
  }
}
